import { useMemo } from 'react';
import { WorkspaceDetail, useListWorkflowTemplates } from '@shared/scenes/workflows/hooks';
import { LinkableWorkflow } from '../relatedCardOptions/RelatedCardLinkingOptions';

interface ReferencableWorkflows {
  loading: boolean;
  workflows: LinkableWorkflow[];
}

export function useReferenceableWorkflows(
  parentWorkflowTemplateId: string,
  workspaceDetails: Map<string, WorkspaceDetail>,
): ReferencableWorkflows {
  // TODO don't load all
  const { workflowTemplates, loading } = useListWorkflowTemplates({
    input: {
      relatesToWorkflowTemplateId: parentWorkflowTemplateId,
    },
    loadAll: true,
  });

  const referenceableWorkflows = useMemo(() => {
    return workflowTemplates?.map(template => toLinkableWorkflow(template, workspaceDetails)) ?? [];
  }, [workflowTemplates, workspaceDetails]);

  return { loading, workflows: referenceableWorkflows };
}

function toLinkableWorkflow(
  template: MBAPI.WorkflowTemplate,
  workspaceDetails: Map<string, WorkspaceDetail>,
): LinkableWorkflow {
  return {
    workflowTemplateId: template.id,
    imageUrl: template.channelDefaultConfiguration?.imageUrl ?? '',
    name: workspaceDetails.get(template.id)?.name ?? template.name,
    components: template.components,
  };
}
